import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MercheMarketplaceRoutingModule } from './merche-marketplace-routing.module';
import { MarketplaceComponent } from './marketplace/marketplace.component';
import { MerchMarketComponent } from './merch-market/merch-market.component';
import { ProductMarketplaceComponent } from './product-marketplace/product-marketplace.component';
import { OverviewProductComponent } from './overview-product/overview-product.component';
import { CoreModule } from 'src/app/core/core.module';
import { DirectivesModule } from 'src/app/core/directives/directives.module';
import { GotoCratdialogComponent } from './goto-cratdialog/goto-cratdialog.component';
// import { ProductShoppingcartComponent } from './product-shoppingcart/product-shoppingcart.component';
import { ShippingProductComponent, ProductConfirmationDialog } from './shipping-product/shipping-product.component';
import { ProductShoppingcartComponent } from './product-shoppingcart/product-shoppingcart.component';
import { EventMarketplaceComponent } from './event-marketplace/event-marketplace.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NetworkMerchandiseComponent } from './network-merchandise/network-merchandise.component';
import { FilterDropdownComponent } from './filter-dropdown/filter-dropdown.component';
import { CartPopupComponent } from './cart-popup/cart-popup.component';
@NgModule({
  declarations: [
    MarketplaceComponent,
    GotoCratdialogComponent,
    MerchMarketComponent,
    ProductMarketplaceComponent,
    OverviewProductComponent,
    ProductShoppingcartComponent,
    ShippingProductComponent,
    EventMarketplaceComponent,
    ProductConfirmationDialog,
    NetworkMerchandiseComponent,
    FilterDropdownComponent,
    CartPopupComponent
  ],
  imports: [
    CommonModule,
    MercheMarketplaceRoutingModule,
    CoreModule,
    DirectivesModule,
    InfiniteScrollModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatMomentDateModule,

  ],
  exports: [
    MerchMarketComponent,
    EventMarketplaceComponent,
    NetworkMerchandiseComponent,
    ProductMarketplaceComponent,
    OverviewProductComponent,
    ProductShoppingcartComponent,
    ShippingProductComponent,
    MarketplaceComponent,
    FilterDropdownComponent,
    CartPopupComponent
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],

})
export class MercheMarketplaceModule { }
